import { z } from 'zod';
export const AP_INBOX_MAILBOX = 'ap';
export const AP_INBOX_SLUG_MAX_LENGTH = 64;
export const AP_INBOX_SLUG_PATTERN = '^[a-z0-9-]+$';
export const apInboxSlugSchema = z
    .string()
    .min(1)
    .max(AP_INBOX_SLUG_MAX_LENGTH)
    .regex(new RegExp(AP_INBOX_SLUG_PATTERN))
    .brand();
export function formatApInboxAddress(slug, domain) {
    return `${AP_INBOX_MAILBOX}+${slug}@${domain.toLowerCase()}`;
}
export function parseApInboxSlug(recipient, domain) {
    const bracketed = /<([^<>]+)>/.exec(recipient);
    const address = (bracketed ? bracketed[1] : recipient).trim().toLowerCase();
    const prefix = `${AP_INBOX_MAILBOX}+`;
    const suffix = `@${domain.toLowerCase()}`;
    if (!address.startsWith(prefix) || !address.endsWith(suffix))
        return undefined;
    const parsed = apInboxSlugSchema.safeParse(address.slice(prefix.length, -suffix.length));
    return parsed.success ? parsed.data : undefined;
}
export const apIntakeExceptionReasonSchema = z.enum([
    'unknown-inbox',
    'inactive-inbox',
    'deleted-ownership',
    'no-attachments',
    'unreadable-attachments',
]);
export const invoiceIntakeFlagSchema = z.discriminatedUnion('kind', [
    z.object({ kind: z.literal('non-standard-attachment-type'), mimeType: z.string() }),
    z.object({ kind: z.literal('unknown-sender'), sender: z.string() }),
    z.object({ kind: z.literal('unread-attachments'), filenames: z.array(z.string()).min(1) }),
]);
//# sourceMappingURL=apIntake.js.map